import type { FC } from 'react';

import { cva } from 'class-variance-authority';

import { cn } from '@wwe-portal/ui/lib/lib';

import { OfferCardTypeEnum } from '@wwe-portal/entities/offer.type';

export interface OfferLayoutProps {
  header: React.ReactNode;
  footer: React.ReactNode;
  timeLeft?: React.ReactNode;
  items?: React.ReactNode;
  stockQuantity?: React.ReactNode;
  cardType: OfferCardTypeEnum;
}

const containerVariants = cva('absolute inset-y-0', {
  variants: {
    cardType: {
      [OfferCardTypeEnum.SINGLE3]: 'inset-x-[calc(100%/108)]',
      [OfferCardTypeEnum.SINGLE2]: 'inset-x-[calc(200%/167)]',
      [OfferCardTypeEnum.SINGLE1]: 'inset-x-[calc(400%/348)]',
    },
  },
});

export const OfferLayout: FC<OfferLayoutProps> = ({
  header,
  footer,
  timeLeft,
  items,
  stockQuantity,
  cardType,
}) => {
  const isSingle3 = cardType === OfferCardTypeEnum.SINGLE3;
  const isSingle1OrSingle2 =
    cardType === OfferCardTypeEnum.SINGLE1 ||
    cardType === OfferCardTypeEnum.SINGLE2;
  return (
    <div className={cn(containerVariants({ cardType }))}>
      <div className="h-full w-full">
        <div
          className={cn('relative pt-1', {
            'h-[calc(3200%/167)]': isSingle3,
            'h-[calc(4200%/167)]': isSingle1OrSingle2,
          })}
        >
          {header}
        </div>
        <div
          className={cn('relative', {
            'h-[calc(11100%/167)]': isSingle3,
            'h-[calc(9500%/167)]': isSingle1OrSingle2,
          })}
        >
          {items ? (
            <div className="absolute inset-x-0 bottom-[calc(2000%/111)] h-[calc(7200%/111)]">
              {items}
            </div>
          ) : null}

          {stockQuantity ? (
            <div
              className={cn('absolute left-1.5 top-0', {
                'left-3': cardType === OfferCardTypeEnum.SINGLE1,
              })}
            >
              {stockQuantity}
            </div>
          ) : null}
          {timeLeft ? (
            <div className="absolute -right-[2px] h-[14px]">{timeLeft}</div>
          ) : null}
        </div>
        <div
          className={cn('relative py-1', {
            'h-[calc(3000%/167)]': isSingle1OrSingle2,
            'h-[calc(2400%/167)]': isSingle3,
          })}
        >
          {footer}
        </div>
      </div>
    </div>
  );
};
